module.exports = __webpack_public_path__ + "assets/0d483153590323141a5f82ffdf48d2a1.jpg";